'use client'

import * as React from 'react'

import { typographyVariants } from '@ui/web/lib'
import cn from '@config/tailwind/cn'

export interface FilterPill {
  label: string
  value: string
}

interface ContentFilterPillsProps {
  activeFilter?: string
  filters?: FilterPill[]
  onFilterChange?: (value: string) => void
  className?: string
}

export function ContentFilterPills({ activeFilter, filters = [], onFilterChange, className }: ContentFilterPillsProps) {
  if (filters.length === 0) return null

  return (
    <div className={cn('srd:flex srd:items-center srd:gap-x-2 srd:overflow-x-auto srd:pb-1 srd:px-4', className)}>
      {filters.map((filter) => (
        <button
          key={filter.value}
          type='button'
          onClick={() => onFilterChange?.(filter.value)}
          className={cn(
            'srd:shrink-0 srd:px-4 srd:py-1.5 srd:rounded-xl srd:border srd:transition-colors',
            typographyVariants({ variant: 'label-md' }),
            activeFilter === filter.value
              ? 'srd:bg-blue-30 srd:text-navy-80 srd:border-blue-30'
              : 'srd:bg-transparent srd:text-grey-70 srd:border-blue-70',
          )}
        >
          {filter.label}
        </button>
      ))}
    </div>
  )
}
